import { Component, OnInit } from "@angular/core";
import { MenuService } from "../menuService/api/menu.service";
import { Router } from "@angular/router";
import { UtilityService } from "../../shared/utility.service";

// import{ permission} from '../../../assets/json/mock/permission.json'
@Component({
  selector: "app-permission-mgmt",
  templateUrl: "./permission-mgmt.component.html",
  styleUrls: ["./permission-mgmt.component.scss"],
})
export class PermissionMgmtComponent implements OnInit {
  config: any;
  permissionData: any;
  editFlag = false;
  paginationCount: number;
  filterFlag: boolean = false;
  defaultPage: any;
  filterObj: any;
  page: any;
  size: any;
  constructor(
    private menu: MenuService,
    private router: Router,
    private us: UtilityService
  ) {
    this.defaultPage = {
      page: {
        number: 0,
        size: this.size,
      },
    };
  }

  getPageConfig() {
    this.menu.getMenuPageConfig().subscribe((res: any) => {
      this.config = res;
    });
  }
  getRole(filterObj) {
    this.menu.getPermissionData(filterObj).subscribe((res) => {
      this.permissionData = res[0];
      this.paginationCount = res[1];
    });
  }
  handleEvent(event) {
    this.getPageConfig();
    if (event.name == "LAZY_LOAD") {
      this.page = this.us.PaginationPerPage(event.event);
      this.defaultPage.page.size = event.event.rows;
      if (this.filterFlag) {
        this.filterObj.page = this.page;
        this.getRole(this.filterObj);
      } else {
        this.getRole({ page: this.page });
      }
    }
  }
  onEdit(roleData) {
    let roleId = roleData ? roleData.id : null;
    this.router.navigate(["/edit/" + roleId]);
  }
  ngOnInit() {
    this.getPageConfig();
  }
}
